export enum ROUTE {
  DONATION = '/donation',
  SUPPORTER = '/supporter',
  PAYMENT = '/payment',
  THANK_YOU = '/thankyou',
}
